module.exports = __webpack_public_path__ + "2b8f10ed1dbb4471a8ebea15f56b26ff.pdf";